module.exports = {
  MONTHLY: 'monthly',
  ANNUAL: 'annual'
}
